var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('nav-bar',{attrs:{"theme":"light","background-color":"nothing","haveOpacity":true}}),_c('v-row',[_c('v-img',{attrs:{"width":"100%","src":require("@/assets/images/profile/profile-header.png")}})],1),_c('div',{staticClass:"profile-header"},[_c('profile-header')],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }